const cookies = {
  referralCode: 'referral_code'
}

export default cookies
